module.exports = __webpack_public_path__ + "static/media/light-rays.8d92603c.svg";